import { ColDef } from '@ag-grid-community/core';
import * as moment from 'moment';
import { tooltipRenderer } from 'src/app/shared/helpers/tooltip-renderer';
import { numberValueFormatter } from 'src/app/shared/helpers/number-value-formatter';
import { CashReconcilationComponent } from '../cash-reconcilation.component';
const filterParams = {
  maxNumConditions: 1,
  debounceMs: 700,
};
export const COL_DEFS_Left: (
  component: CashReconcilationComponent,
) => ColDef[] = (component) => [
  {
    headerName: 'ID',
    field: 'debtorId',
    filter: 'agTextColumnFilter',
    width: 115,
    colId: 'debtorId',
    suppressMovable: true,
    filterParams: filterParams,
    floatingFilter: false,
    suppressMenu: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellRenderer: tooltipRenderer,
  },
  {
    headerName: 'Name',
    field: 'debtorName',
    filter: 'agTextColumnFilter',
    width: 140,
    colId: 'debtorName',
    suppressMovable: true,
    filterParams: filterParams,
    floatingFilter: false,
    suppressMenu: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellRenderer: tooltipRenderer,
  },
  {
    headerName: 'Receipt',
    field: 'receipt',
    filter: 'agTextColumnFilter',
    width: 95,
    colId: 'receipt',
    cellClass: 'ag-right-aligned-cell',
    filterParams: filterParams,
    valueFormatter: numberValueFormatter,
    suppressMovable: true,
    floatingFilter: false,
    suppressMenu: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellRenderer: tooltipRenderer,
  },
];

export const COL_DEFS_Right: (
  component: CashReconcilationComponent,
) => ColDef[] = (component) => [
  {
    headerName: 'Trade ID',
    field: 'tradeId',
    filter: 'agTextColumnFilter',
    width: 115,
    colId: 'tradeId',
    hide: false,
    suppressMovable: true,
    filterParams: filterParams,
    floatingFilter: false,
    suppressMenu: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    headerName: 'Name',
    field: 'debtor.entity.name',
    filter: 'agTextColumnFilter',
    width: 140,
    colId: 'debtorName',
    hide: false,
    suppressMovable: true,
    filterParams: filterParams,
    floatingFilter: false,
    suppressMenu: true,
    floatingFilterComponentParams: { suppressFilterButton: true },
  },
  {
    headerName: 'Face Value',
    field: 'faceValue',
    filter: 'agTextColumnFilter',
    width: 95,
    colId: 'faceValue',
    suppressMovable: true,
    cellClass: 'ag-right-aligned-cell',
    filterParams: filterParams,
    valueFormatter: numberValueFormatter,
    floatingFilter: false,
    suppressMenu: true,
    hide: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellRenderer: tooltipRenderer,
  },
];

export function dateValueFormatter(dateString: any) {
  if (dateString) {
    const dateMoment = new Date(dateString);
    return !isNaN(dateMoment.getTime())
      ? moment(dateString).format('YYYY-MM-DD')
      : null;
  }
  return dateString;
}

export function CustomDateValueFormatter(params: any) {
  const parsedDate = new Date(params.value);
  if (!isNaN(parsedDate.getTime()))
    return params.value ? moment(params.value).format('YYYY-MM-DD') : '';
  return params.value;
}

export const Keys_UnallocatedPayments = [
  'debtorId',
  'debtorName',
  'paymentDate',
  'dateEntered',
  'ccy',
  'amountReceived',
];
